import script from "./ProductCustomizationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCustomizationModal.vue?vue&type=script&setup=true&lang=ts"

import "./ProductCustomizationModal.vue?vue&type=style&index=0&id=00831634&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00831634"]])

export default __exports__